import { r as returnScreenSize } from './screen-89b22340.js';
import { s as setRootAttribute } from './utils-1cea37e8.js';

const DEFAULT_GROUP_NAME = 'FLYOUT_DEFAULT_GROUP';
/**
 * Allows to assign flyouts to groups and helps with controlling those groups.
 *
 * @internal
 */
class FlyoutGroups {
  constructor() {
    this.groups = new Map();
  }
  /**
   * Register a new flyout component.
   * @param el Component.
   * @param groupName Flyout group name.
   */
  registerFlyout(el, groupName) {
    const existingEls = this.groups.get(groupName || DEFAULT_GROUP_NAME);
    const els = existingEls != null ? [...existingEls, el] : [el];
    const group = groupName || DEFAULT_GROUP_NAME;
    this.groups.set(group, els);
  }
  /**
   * Unregister a flyout component from the specified group
   * @param el Component.
   * @param groupName Flyout group name.
   */
  unregisterFlyout(el, groupName) {
    const group = groupName || DEFAULT_GROUP_NAME;
    const els = this.groups.get(group);
    const index = els.findIndex(x => x.hostElement === el);
    if (index >= 0) {
      const newEls = els.splice(index, 1);
      this.groups.set(group, newEls);
    }
  }
  /**
   * Close all flyout components, except the provided 'el'.
   * @param el Component.
   * @param groupName Flyout group name.
   */
  closeAllOtherGroupFlyouts(el, groupName) {
    var _a;
    (_a = this.groups.get(groupName || DEFAULT_GROUP_NAME)) === null || _a === void 0 ? void 0 : _a.forEach(component => {
      if (component.hostElement !== el.hostElement) {
        component.closeFlyoutmenu().catch(console.warn);
      }
    });
  }
}

/**
 * Method used to setup Patternlib globals.
 * @returns
 */
function setupPatternlibRuntime() {
  var _a;
  // TODO: Remove with 3.0
  if (window != null) {
    const screenSize = returnScreenSize();
    setRootAttribute('breakpoint', screenSize);
    window.addEventListener('resize', function () {
      const screenSize = returnScreenSize();
      setRootAttribute('breakpoint', screenSize);
    });
    const context = (_a = document === null || document === void 0 ? void 0 : document.documentElement) === null || _a === void 0 ? void 0 : _a.getAttribute('context');
    if (context == null || context === '') {
      setRootAttribute('context', 'portal');
    }
    window['PatternlibFlyoutGroups'] = new FlyoutGroups();
    if (!('Patternlib' in window)) {
      window['Patternlib'] = new PatternlibService();
    }
  }
}
/**
 * PatternlibService class.
 */
class PatternlibService {
  /**
   * Updates the root attributes.
   */
  static updateSettings(newSettings) {
    const theme = newSettings.theme;
    const context = newSettings.context;
    PatternlibService.updateRootAttribute(context, theme);
  }
  static setTheme(theme) {
    setRootAttribute('theme', theme);
  }
  /**
   * Pass through method for FlyoutGroups.
   */
  static registerFlyout(el, groupName) {
    window['PatternlibFlyoutGroups'].registerFlyout(el, groupName);
  }
  static unregisterFlyout(el, groupName) {
    window['PatternlibFlyoutGroups'].unregisterFlyout(el, groupName);
  }
  static closeAllOtherFlyouts(el, groupName) {
    window['PatternlibFlyoutGroups'].closeAllOtherGroupFlyouts(el, groupName);
  }
  static updateRootAttribute(context, theme) {
    if (context != null) {
      setRootAttribute('context', context);
    }
    if (theme != null) {
      setRootAttribute('theme', theme);
    }
  }
}

export { PatternlibService as P, setupPatternlibRuntime as s };
